<section class="welcome-wrap">
  <div class="wrap-lg">
    <div class="welcome-inner">
      <div class="nav-sec">
        <div class="back-nav" (click)="util.route('home')">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 6L9 12L15 18" stroke="#1A204B" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="nav-name">Back</span>
        </div>
      </div>
      <div class="box-wrap">
        <div class="welcome-content">
          <div class="left">
            <img src="assets/images/welcome.svg" alt="Welcome Image"/>
          </div>
          <div class="right">
            <div class="welcome-title">Hello {{name | titlecase}}</div>
            <div class="welcome-info">Welcome to Northern Arc</div>
            <div class="welcome-desc">{{message}}</div>
            <!-- <div class="welcome-sign"><img src="assets/images/sign.svg" alt="Image"/></div> -->
            <!-- <div class="welcome-role">CEO, Northern Arc</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
